

































































import { Vue, Component } from "vue-property-decorator";
@Component({
  name: "Element",
})
export default class Element extends Vue {
  private show1 = false;
  private show2 = false;
  private show3 = false;
  private show4 = false;
  private show5 = false;
  private show6 = false;
  private modalVisible = false;

  private mounted() {
    this.show1 = true;
    this.show2 = true;
    this.show3 = true;
    this.show4 = true;
    this.show5 = true;
    this.show6 = true;
  }

  private trans(field: string) {
    this[field] = false;
    setTimeout(() => {
      this[field] = true;
    }, 200);
  }

  private open() {
    this.modalVisible = true;
  }
  private close() {
    this.modalVisible = false;
  }
}
